import React, { useEffect, useState } from "react";
import {
  chipValue,
  requestStyle,
  quoteChipColor,
  chipColor,
  chipStyle,
} from "../data/styleData";
import {
  Button,
  Chip,
  useDisclosure,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  Select,
  SelectItem,
  User,
  Textarea,
} from "@nextui-org/react";
import { refreshIfNeeded } from "../store/actions/refreshIfNeeded";

import { useSelector, useDispatch } from "react-redux";
import UpdateLayout from "./UpdateLayout";
import { toast } from "react-toastify";
import axios from "axios";
import { getQuoteById } from "../store/slices/customerSlice";
import { ChatBox } from "../routes";
import TransactionDetails from "../components/TransactionDetails";
import PaymenetModal from "../components/PaymenetModal";
import { useNavigate } from "react-router-dom";
import RevertModal from "./RevertModal";

const AcceptQuoteLayout = ({ handleOrder, request, bill }) => {
  const [showAccountConfirmation, setShowAccountConfirmation] = useState(false);
  const role = localStorage.getItem("role");
  const dipatch = useDispatch();
  const [bills, setBills] = useState({});
  const customers = JSON.parse(localStorage.getItem("customer_request"));
  const SupplierUser = useSelector((state) => state.customer.user);
  const dispatch = useDispatch();
  const [note, setNote] = useState("");
  const [sending, setSending] = useState(false);
  const [existingNote, setExistingNote] = useState("");
  const [loadingNote, setLoadingNote] = useState(false);
  const [ordering, setOrdering] = useState(false);

  const [customerDetails, setCustomerDetails] = useState([]);

  // Open modals only after ensuring fresh token
  const openConfirmModalWithAuth = async () => {
    await ensureAuth();
    setIsModalOpen(true);
  };
  const openRevertModalWithAuth = async () => {
    await ensureAuth();
    setisRevertModalOpen(true);
  };

  // ---- Auth helpers (fresh token on demand) ----
  const [authReady, setAuthReady] = useState(false);

  const authHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });

  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };
  const openPaymentWithAuth = async () => {
    await dispatch(refreshIfNeeded());
    onPayment();
  };

  const {
    supplier_id,
    quote,
    reps,
    orderDetails,
    singleRequest,
    user,
    Payments,
    quote_images,
  } = useSelector((state) => state.customer);
  const navigate = useNavigate();
  const {
    isOpen: paymentOpen,
    onOpen: onPayment,
    onClose: paymentClose,
  } = useDisclosure();

  // console.log(
  //   quote,
  //   'customer---->>>')

  // console.log("Quoteee Redux--->>>>>>>,",quote)
  // console.log(quote?.freight_price, 'quotelayout----->>>', bill, 'bill', bills)

  useEffect(() => {
    if (singleRequest?.customer_id) {
      getCustomerDetails();
    }
  }, [authReady, singleRequest?.customer_id]);
  useEffect(() => {
    (async () => {
      await ensureAuth(); // refresh token on page load
      setAuthReady(true); // render only after token is fresh
    })();
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(getUserDetails());
  // }, [dispatch]);
  const getCustomerDetails = async () => {
    if (!singleRequest?.customer_id) return;
    try {
      const headers = await ensureAuth(); // ✅ fresh token
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/users/profile/${singleRequest.customer_id}`,
        {
          ...headers,
          headers: { ...headers.headers, "Content-Type": "application/json" },
        }
      );
      setCustomerDetails(res.data?.details);
    } catch {}
  };

  const handleOrderWithAuth = async () => {
    if (ordering) return;
    setOrdering(true);
    try {
      await ensureAuth(); // ✅ token refresh here
      await Promise.resolve(handleOrder?.());
    } catch (e) {
      const msg = e?.response?.data?.message || "Failed to generate order";
      toast.error(msg);
    } finally {
      setOrdering(false);
    }
  };

  const handleSendNote = async () => {
    if (!note.trim()) {
      toast.error("Please enter a note before sending");
      return;
    }

    try {
      setSending(true);

      const headers = await ensureAuth();
      await axios.post(
        `${process.env.REACT_APP_SERVER_URL_V2}/quotes/sendnote/${quote?.id}`,
        { note },
        {
          ...headers,
          headers: { ...headers.headers, "Content-Type": "application/json" },
        }
      );

      toast.success("Note sent successfully");
      setNote("");
    } catch (error) {
      const err = error?.response?.data?.message || "Failed to send note";
      toast.error(err);
    } finally {
      setSending(false);
    }
  };
  const fetchExistingNote = async () => {
    if (!quote?.id) return;
    try {
      setLoadingNote(true);
      const headers = await ensureAuth(); // ✅ fresh token
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL_V2}/quotes/getnote/${quote.id}`,
        headers
      );
      setExistingNote(res?.data?.details?.message?.note ?? "");
    } finally {
      setLoadingNote(false);
    }
  };

  useEffect(() => {
    if (role === "SUPPLIER") fetchExistingNote();
  }, [authReady, role, quote?.id]);

  const handleAccountClick = () => {
    setShowAccountConfirmation(true);
  };

  const handleConfirmationYes = () => {
    handelCapriconOrAccountPayment(2);
    setShowAccountConfirmation(false);
  };

  const handleConfirmationNo = () => {
    setShowAccountConfirmation(false);
  };

  function recieptList(quote) {
    let freight_price = quote.freight_price_price || 0;
    let part_price = quote.part_price || 0;
    let warranty_price = quote.warranty_price || 0;

    const recieptObj = {};
    const quantity = request?.quantity || 1;
    const totalPrice = freight_price + part_price * quantity + warranty_price;
    const applyTax = quote?.applyTax;
    const taxRate = 10 / 100;

    if (applyTax) {
      recieptObj.totalTax = Number((totalPrice * taxRate).toFixed(2));
      recieptObj.freightPrice = freight_price;
      recieptObj.partPrice = part_price;
      recieptObj.warrantyPrice = warranty_price;
      recieptObj.totalPrice = Number(
        (totalPrice + (totalPrice * 10) / 100).toFixed(2)
      );
    } else {
      recieptObj.totalTax = Number(
        (totalPrice - (totalPrice * 10) / 11).toFixed(2)
      );
      recieptObj.freightPrice = Number(
        (freight_price / (1 + taxRate)).toFixed(2)
      );
      recieptObj.partPrice = Number((part_price / (1 + taxRate)).toFixed(2));
      recieptObj.warrantyPrice = Number(
        (warranty_price / (1 + taxRate)).toFixed(2)
      );
      recieptObj.totalPrice = Number(totalPrice);
    }

    return recieptObj;
  }

  const handleStripePayment = async () => {
    try {
      const headers = await ensureAuth();
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/payment/checkout/${quote?.id}/3`,
        {},
        {
          ...headers,
          headers: { ...headers.headers, "Content-Type": "application/json" },
        }
      );
      const paymentLink = res.data.paymentLink;
      paymentClose();
      window.open(paymentLink, "_blank");
    } catch (error) {
      const err = error?.response?.data?.message;
      toast.error(err);
    }
  };

  const handelCapriconOrAccountPayment = async (method, capricornNumber) => {
    try {
      paymentClose();
      const headers = await ensureAuth();
      await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/payment/checkout/${quote?.id}/${method}`,
        { capricornNumber: capricornNumber },
        {
          ...headers,
          headers: { ...headers.headers, "Content-Type": "application/json" },
        }
      );

      dipatch(getQuoteById(quote?.id));
    } catch (error) {
      const err = error?.response?.data?.message;
      toast.error(err);
    }
  };

  const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRevertModalOpen, setisRevertModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleOpenModal2 = () => {
    setisRevertModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const RevertModalClose = () => {
    setisRevertModalOpen(false);
  };

  const handleConfirmPayment = async () => {
    // const apiUrl = (role == 'CUSTOMER'
    //   ? `${process.env.REACT_APP_SERVER_URL}/payment/${quote?.id}/status/confirmed`
    //   : `${process.env.REACT_APP_SERVER_URL}/payment/${quote?.id}/status/paid`);
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/payment/${quote?.id}/status/paid`;
    // const apiUrl = `https://m85m05gl-8081.inc1.devtunnels.ms/api/v1/payment/${quote?.id}/status/paid`
    try {
      const headers = await ensureAuth();
      const response = await axios.post(
        apiUrl,
        {},
        {
          ...headers,
          headers: { ...headers.headers, "Content-Type": "application/json" },
        }
      );
      toast.success(`${response.data?.message} ⭐`);
      dipatch(getQuoteById(quote?.id));

      // if (response.data?.message === "Paid succesfully") {
      //   navigate("/quotes");
      // }
    } catch (error) {
      const err = error?.response?.data?.message || "Payment failed!";
      toast.error(err);
    }
  };

  useEffect(() => {
    getCustomerDetails();
    if (Object.keys(quote).length > 0) {
      const bill = recieptList(quote);
      // console.log(bill, "BILlllll---------->>");
      setBills(bill);
    }
    if (orderDetails) {
      let status = orderDetails?.OrderStatus?.status;
      if (status === "Dispute") {
        toast.error("Your order has been disputed!");
      }
    } else {
      if (role === "CUSTOMER") {
        // toast.info("Order is not generated by supplier");
      }
    }
  }, [supplier_id, quote, orderDetails, singleRequest, user, quote_images]);
  if (!authReady) return null;

  return (
    <div>
      {quote?.Payments?.length > 0 && (
        <Chip
          color="secondary"
          variant="dot"
          className="float-right text-purple-400 border-[2px] border-purple-400 ml-2"
        >
          <p>{quote?.Payments?.at(-1)?.paymentMethod}</p>
        </Chip>
      )}

      {quote?.Payments?.at(-1)?.status === "Paid" ? (
        <>
          <Chip
            color={chipColor["Accepted"]}
            variant="dot"
            className="float-right text-green-400 border-[2px]  border-green-400"
          >
            <p>{quote?.Payments?.at(-1)?.status || "Paid"}</p>
          </Chip>
        </>
      ) : (
        <Chip
          color={chipColor["Rejected"]}
          variant="dot"
          className="float-right text-red-400 border-[2px] border-red-400"
        >
          <p>{quote?.Payments?.at(-1)?.status || "Unpaid"}</p>
        </Chip>
      )}

      <UpdateLayout
        heading={"Accepted Quote"}
        title={""}
        images={quote_images}
        requestId={quote?.request_id}
        quoteId={quote?.id}
      >
        {singleRequest?.RequestStatus?.status === "Accepted" &&
          quote?.Payments?.at(-1) &&
          ["Unpaid", "Reverted", "Confirmed"].includes(
            quote?.Payments?.at(-1)?.status
          ) && (
            <div className="mb-2  space-y-[4px]">
              <div className="flex justify-between items-center">
                <p className="font-semibold">Customer Details</p>

                {role === "SUPPLIER" && (
                  <div className="text-sm mt-3">
                    <p className="font-semibold">
                      Company Name:{" "}
                      <span className="font-normal">
                        {quote?.User?.company_name || "Not Provided"}
                      </span>
                      {/* {console.log("Company Name------>>",quote)} */}
                    </p>
                    {quote?.Payments?.[0]?.paymentMethod === "Capricorn" && (
                      <div>
                        <p className="font-semibold">
                          Capricorn Number:{" "}
                          <span className="font-normal">
                            {quote?.User?.capricorn_number || "Not Provided"}
                          </span>
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="flex gap-4 mt-8">
                <User
                  description=""
                  avatarProps={{
                    src: `${customerDetails?.user?.profile_id}`,
                  }}
                  className="font-semibold"
                />
                <div>
                  <p>
                    {customerDetails?.user?.first_name}{" "}
                    {customerDetails?.user?.last_name}
                  </p>
                  <p className="text-sm">{customerDetails?.user?.email}</p>
                </div>
                {/* <p>
                  {customerDetails?.user?.capricorn_number &&
                    `(Capricorn Member: ${customerDetails?.user?.capricorn_number} )`}
                </p> */}
              </div>
              <div className="grid grid-cols-4 gap-2 [&>div]:text-center [&>div]:text-[0.8rem] [&>div>p:first-child]:font-semibold [&>div>p:first-child]:text-[0.9rem] mt-7">
                <div>
                  <p>Phone no.</p>
                  <p>{customerDetails?.user?.phone}</p>
                </div>
                <div>
                  <p>City</p>
                  <p>{customerDetails?.user?.suburb}</p>
                </div>

                <div>
                  <p>State</p>
                  <p>{customerDetails?.user?.state}</p>
                </div>
                <div>
                  <p>Postcode</p>
                  <p>{customerDetails?.user?.postcode}</p>
                </div>
              </div>
            </div>
          )}
        {role === "CUSTOMER" &&
          singleRequest?.RequestStatus?.status === "Accepted" &&
          quote?.Payments?.at(-1) &&
          ["Unpaid", "Reverted", "Confirmed"].includes(
            quote?.Payments?.at(-1)?.status
          ) && (
            <div className="text-sm">
              <p className="font-semibold">Supplier Details</p>
              <div className="flex justify-between px-5 mt-4">
                <div>
                  <p className="font-semibold">Supplier Name:</p>
                  <p className="font-normal">
                    {`${quote?.User?.first_name || ""} ${
                      quote?.User?.last_name || ""
                    }`.trim() || "Not Provided"}
                  </p>
                </div>
                <div>
                  <p className="font-semibold">Phone Number:</p>
                  <p className="font-normal">
                    {quote?.User?.phone || "Not Provided"}
                  </p>
                </div>
                <div>
                  <p className="font-semibold">Email:</p>
                  <p className="font-normal">
                    {quote?.User?.email || "Not Provided"}
                  </p>
                </div>
              </div>
            </div>
          )}

        <div className="mt-4 ">
          <div className="flex justify-between items-center ">
            <p className="font-semibold">Request Details:</p>
            <Chip
              color={quoteChipColor[quote?.status]}
              variant="dot"
              className={requestStyle[quote?.status]}
            >
              <p>{chipValue[quote?.status]}</p>
            </Chip>
          </div>
          <div
            className="grid grid-cols-2 sm:grid-cols-4 capitalize  [&>div]:text-center [&>div]:text-[0.8rem] [&>div>p:first-child]:font-semibold 
          [&>div>p:first-child]:text-[0.9rem] mt-4 "
          >
            <div>
              <p className="capitalize">Vehicle Make</p>
              <p>
                {singleRequest?.VehicleMake?.name
                  ? capitalize(singleRequest.VehicleMake.name.toLowerCase())
                  : capitalize(singleRequest?.custom_make)}
              </p>
            </div>
            <div>
              <p>Vehicle Model</p>
              <p>
                {singleRequest?.VehicleModel?.name
                  ? capitalize(singleRequest?.VehicleModel?.name.toLowerCase())
                  : capitalize(singleRequest?.custom_model)}
              </p>
            </div>
            <div>
              <p>Vehicle Part</p>
              <p>
                {singleRequest?.Part
                  ? capitalize(singleRequest?.Part?.name.toLowerCase())
                  : capitalize(singleRequest?.custom_part_type)}
              </p>
            </div>
            <div>
              <p>Quantity</p>
              <p>{singleRequest?.quantity} Qnty</p>
            </div>
            {/* <div>
              <p>Rego</p>
              <p>{singleRequest?.rego}</p>
            </div> */}
            {/* ── Rego | VIN | Description ── */}
            <div>
              {singleRequest?.rego ? (
                /* 1️⃣ show Rego, if it exists */
                <>
                  <p>Rego</p>
                  <p>{singleRequest.rego}</p>
                </>
              ) : singleRequest?.vin ? (
                /* 2️⃣ otherwise show VIN, if it exists */
                <>
                  <p>VIN</p>
                  <p>{singleRequest.vin}</p>
                </>
              ) : singleRequest?.prof_descreption ? (
                /* 3️⃣ otherwise show Description, if it exists */
                <>
                  <p>Description</p>
                  <p>{singleRequest.prof_descreption}</p>
                </>
              ) : (
                /* 4️⃣ none of the three fields had data */
                <>
                  <p>Rego</p>
                  <p>Not Provided</p>
                </>
              )}
            </div>

            <div>
              <p className="capitalize">Fuel Type</p>
              <p>
                {singleRequest?.fuelType?.name.toLowerCase() || "Not Provided"}
              </p>
            </div>
            <div>
              <p className="capitalize">Transmission</p>
              <p>
                {singleRequest?.transmissionModel?.name.toLowerCase() ||
                  "Not Provided"}
              </p>
            </div>
            <div>
              <p>Body Style</p>
              <p>{singleRequest?.bodyStyle?.name || "Not Provided"}</p>
            </div>
            <div className="col-span-2 sm:col-span-4 mt-4  ">
              <span className="text-[0.9rem] font-semibold">Note: </span>
              <span>
                {singleRequest?.notes === ""
                  ? "Not Provided"
                  : singleRequest?.notes}
              </span>
            </div>
          </div>
        </div>
        <div>
          <div className="flex justify-between mt-2  ">
            <p className="font-semibold">Quote Details:</p>
            <Chip
              color={quoteChipColor[quote?.status]}
              variant="dot"
              className={requestStyle[quote?.status]}
            >
              <p>{chipValue[quote?.status]}</p>
            </Chip>
          </div>
          <div className="grid grid-cols-4 gap-2   [&>div]:text-center [&>div]:text-[0.8rem] [&>div>p:first-child]:font-semibold [&>div>p:first-child]:text-[0.9rem] mt-4">
            <div>
              <p>Part Price</p>
              <p>${Number(quote?.part_price).toFixed(2)}</p>
            </div>
            <div>
              <p>Freight Price</p>
              <p>${Number(quote?.freight_price).toFixed(2)}</p>
            </div>
            <div>
              <p>Total Price</p>
              <p>${Number(quote?.total_price).toFixed(2)}</p>
            </div>
            <div>
              <p>Sales Rep</p>
              <p>{quote?.SupplierSalesRep?.SalesRepName}</p>
            </div>

            <div>
              <p>Warranty</p>
              <p>
                {quote?.warrantyDuration?.duration}{" "}
                {quote?.warrantyDuration?.unit}
              </p>
            </div>

            <div>
              <p>Warranty Option</p>
              <p>
                {quote?.warranty_option
                  ? capitalize(quote.warranty_option)
                  : "Not Provided"}
              </p>
            </div>

            <div>
              <p>Warranty Price</p>
              <p>
                $
                {Number(
                  quote?.warranty_price ? quote?.warranty_price : "0"
                ).toFixed(2)}
              </p>
            </div>

            <div>
              <p>Shipping Date</p>
              <p>{quote?.shipping_date?.split("T")[0]}</p>
            </div>
            <div className="col-span-2 sm:col-span-4 mt-4   ">
              <span className="text-[0.9rem] font-semibold">Note: </span>
              <span>{quote?.notes === "" ? "Not Provided" : quote?.notes}</span>
            </div>
          </div>
        </div>

        {role === "CUSTOMER" && (
          <div className="mt-6 flex gap-2 w-full items-center">
            <Textarea
              variant="bordered"
              label="Notes"
              labelPlacement="outside"
              placeholder="Any message"
              value={note}
              minRows={3}
              maxRows={6}
              onChange={(e) => setNote(e.target.value)}
              className="flex-1"
            />

            <Button
              color="primary"
              size="sm"
              radius="sm"
              isLoading={sending}
              onClick={handleSendNote} // CHANGE: switched from onPress ➜ onClick
            >
              Send
            </Button>
          </div>
        )}
        {role === "SUPPLIER" && (
          <div className="mt-6 w-full space-y-4">
            <Textarea
              isReadOnly
              variant="flat"
              label="Customer note"
              value={loadingNote ? "Loading…" : existingNote || "— No note —"}
              className="w-full"
            />

            {/* Reply area */}
            {/* <div className="flex gap-2 items-center">
              <Textarea
                variant="bordered"
                label="Reply"
                placeholder="Type your message"
                value={note}
                minRows={3}
                maxRows={6}
                onChange={(e) => setNote(e.target.value)}
                className="flex-1"
              />
              <Button
                color="primary"
                size="sm"
                radius="sm"
                isLoading={sending}
                onClick={handleSendNote}
                className="self-start"
              >
                Send
              </Button>
            </div> */}
          </div>
        )}

        <TransactionDetails
          request={quote.Request}
          bill={
            bill !== undefined
              ? { ...bill, partPrice: quote?.part_price }
              : bills
          }
          totalPrice={quote?.total_price}
          hasWarranty={quote?.has_warranty}
          applyTax={quote?.applyTax}
          freightPrice={quote?.freight_price}
          partPrice={quote?.part_price}
          // WarrantyPrice={quote?.warranty_price}
          WarrantyPrice={quote?.has_warranty ? quote?.warranty_price : 0}
        />
        <div className="mt-2 space-y-2">
          {(role !== "CUSTOMER" &&
            quote?.Payments?.at(-1)?.status === "Paid") ||
          (role === "SUPPLIER" &&
            quote?.Payments?.at(-1)?.status === "Paid") ? (
            // <Button
            //   className="w-full border-2 bg-transparent hover:bg-lightBlue hover:text-white font-semibold border-lightBlue text-lightBlue"
            //   onClick={handleOrder}
            // >
            //   {quote?.orderDetails?.OrderStatus?.status === "Initiated"
            //     ? "Order already exist"
            //     : "Generate Order"}
            // </Button>
            <Button
              className="w-full border-2 bg-transparent hover:bg-lightBlue hover:text-white font-semibold border-lightBlue text-lightBlue"
              onClick={handleOrderWithAuth}
              isLoading={ordering} // (NextUI) optional spinner
              disabled={
                ordering ||
                quote?.orderDetails?.OrderStatus?.status === "Initiated"
              }
            >
              {quote?.orderDetails?.OrderStatus?.status === "Initiated"
                ? "Order already exist"
                : "Generate Order"}
            </Button>
          ) : null}
          {role === "SUPPLIER" ? (
            <div className=" mb-12 md:mb-0">
              {/* {quote?.Payments?.length === 0 ||
              (["Stripe", "Capricorn", "Account"].includes(
                quote?.Payments?.at(-1)?.paymentMethod
              ) &&
                (quote?.Payments?.at(-1)?.status === "Unpaid" ||
                  quote?.Payments?.at(-1)?.status === "Reverted")) ? (
                <Button
                  className="w-full border-2 bg-transparent hover:bg-purpleBtn hover:text-white font-semibold border-purpleBtn text-purpleBtn mt-2 disabled:bg-purple-200 disabled:text-purpleBtn disabled:cursor-not-allowed"
                  onClick={handleOpenModal}
                  disabled={quote?.Payments?.at(-1)?.status === "Reverted"}
                >
                  Confirm Payment
                </Button>
              ) : null}

 

              {quote?.Payments?.length === 0 ||
              (["Stripe", "Capricorn", "Account"].includes(
                quote?.Payments?.at(-1)?.paymentMethod
              ) &&
                (quote?.Payments?.at(-1)?.status === "Unpaid" ||
                  quote?.Payments?.at(-1)?.status === "Reverted")) ? (
                <Button
                  className="w-full border-2 bg-transparent hover:bg-purpleBtn hover:text-white font-semibold border-purpleBtn text-purpleBtn mt-2 disabled:bg-purple-200 disabled:text-purpleBtn disabled:cursor-not-allowed"
                  onClick={handleOpenModal2}
                  disabled={quote?.Payments?.at(-1)?.status === "Reverted"}
                >
                  {quote?.Payments?.some(
                    (payment) => payment.status === "Revert Payment"
                  )
                    ? "Reverted"
                    : "Revert Payment"}
                </Button>
              ) : null} */}
              {quote?.Payments?.length > 0 &&
              ["Stripe", "Capricorn", "Account"].includes(
                quote?.Payments?.at(-1)?.paymentMethod
              ) &&
              ["Unpaid", "Reverted"].includes(
                quote?.Payments?.at(-1)?.status
              ) ? (
                <Button
                  className="w-full border-2 bg-transparent hover:bg-purpleBtn hover:text-white font-semibold border-purpleBtn text-purpleBtn mt-2 disabled:bg-purple-200 disabled:text-purpleBtn disabled:cursor-not-allowed"
                  onClick={openConfirmModalWithAuth}
                  disabled={quote?.Payments?.at(-1)?.status === "Reverted"}
                >
                  Confirm Payment
                </Button>
              ) : null}
              {quote?.Payments?.length > 0 &&
              ["Stripe", "Capricorn", "Account"].includes(
                quote?.Payments?.at(-1)?.paymentMethod
              ) &&
              ["Unpaid", "Reverted"].includes(
                quote?.Payments?.at(-1)?.status
              ) ? (
                <Button
                  className="w-full border-2 bg-transparent hover:bg-purpleBtn hover:text-white font-semibold border-purpleBtn text-purpleBtn mt-2 disabled:bg-purple-200 disabled:text-purpleBtn disabled:cursor-not-allowed"
                  onClick={openRevertModalWithAuth}
                  disabled={quote?.Payments?.at(-1)?.status === "Reverted"}
                >
                  {quote?.Payments?.some((p) => p.status === "Revert Payment")
                    ? "Reverted"
                    : "Revert Payment"}
                </Button>
              ) : null}
            </div>
          ) : (
            (!quote?.Payments?.length ||
              quote?.Payment == null ||
              (quote?.Payments?.at(-1)?.paymentMethod === "Stripe" &&
                quote?.Payments?.at(-1)?.Payments?.at(-1)?.status ===
                  "Unpaid") ||
              quote?.Payments?.at(-1)?.status === "Reverted") && (
              // <Button
              //   className="w-full border-2 bg-transparent hover:bg-lightBlue hover:text-white font-semibold border-blue-300 text-lightBlue mb-5 md:mb-0 disabled:bg-blue-100 disabled:text-blue-300 disabled:cursor-not-allowed"
              //   onClick={openPaymentWithAuth}
              //   disabled={
              //     ["Paid", "Unpaid"].includes(
              //       quote?.Payments?.at(-1)?.status
              //     ) &&
              //     ["Stripe", "Capricorn", "Account"].includes(
              //       quote?.Payments?.at(-1)?.paymentMethod
              //     )
              //   }
              // >
              //   Checkout for Payment
              // </Button>
              <Button
                className="w-full border-2 bg-transparent hover:bg-lightBlue hover:text-white font-semibold border-blue-300 text-lightBlue mb-5 md:mb-0 disabled:bg-blue-100 disabled:text-blue-300 disabled:cursor-not-allowed"
                onClick={openPaymentWithAuth}
                disabled={(() => {
                  const p = quote?.Payments?.at(-1);
                  // Disable if Paid (any method)
                  // OR if Unpaid with non-Stripe methods (Capricorn/Account)
                  return p
                    ? p.status === "Paid" ||
                        (p.status === "Unpaid" &&
                          ["Capricorn", "Account"].includes(p.paymentMethod))
                    : false;
                })()}
              >
                Checkout for Payment
              </Button>
            )
          )}
        </div>
      </UpdateLayout>

      <ChatBox quoteId={quote?.id} />
      <Modal
        size={"sm"}
        isOpen={paymentOpen}
        onClose={paymentClose}
        className="p-3"
        placement="center"
      >
        <ModalContent>
          {(paymentClose) => (
            <>
              <ModalBody className="w-full">
                <p className="text-base font-semibold text-center">
                  Select A Payment Method
                </p>
              </ModalBody>
              <ModalFooter className="p-3 mt-4 justify-normal">
                <div className="grid grid-cols-1 gap-3 w-full">
                  {!showAccountConfirmation ? (
                    <>
                      <Button
                        className="w-full bg-purpleBtn font-semibold text-white"
                        onClick={handleStripePayment}
                      >
                        Online/Card
                      </Button>
                      <p className="text-red-600 font-bold text-[10px] pl-3">
                        Make Sure You Have An Active Account With This Supplier
                        To
                        <span className="block text-center">
                          AvoidDelays In Order Processing
                        </span>
                      </p>
                      {customerDetails?.user?.capricorn_number && (
                        <Button
                          type="submit"
                          className="w-full bg-purpleBtn font-semibold text-white"
                          onClick={() =>
                            handelCapriconOrAccountPayment(
                              1,
                              customerDetails?.user?.capricorn_number
                            )
                          }
                        >
                          Capricorn
                        </Button>
                      )}

                      <Button
                        type="submit"
                        className="w-full bg-purpleBtn font-semibold text-white"
                        onClick={handleAccountClick}
                      >
                        Account
                      </Button>
                    </>
                  ) : (
                    <>
                      <p className="font-semibold">
                        Company Name:{" "}
                        <span className="font-normal">
                          {quote?.User?.company_name || "N/A"}
                        </span>
                      </p>
                      <p className="text-base font-semibold text-center">
                        Do you have an account with the supplier?
                      </p>
                      <div className="flex justify-between w-full">
                        <Button
                          className="bg-lightBlue w-full mr-2 text-white"
                          onClick={handleConfirmationYes}
                        >
                          Yes
                        </Button>
                        <Button
                          className="bg-purpleBtn w-full ml-2 text-white"
                          onClick={handleConfirmationNo}
                        >
                          No
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>

      <PaymenetModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmPayment}
        paymentMethod={Payments?.at(-1)?.paymentMethod}
      />

      {/* <RevertModal
        isOpen={isRevertModalOpen}
        onClose={RevertModalClose}
        accessToken={accessToken}
        quoteId={quote?.id}
        onConfirm={() => {
          setIsModalOpen(false);
        }}
      /> */}
      <RevertModal
        isOpen={isRevertModalOpen}
        onClose={RevertModalClose}
        quoteId={quote?.id}
        onConfirmRevert={() => {
          // optionally UI refresh:
          dipatch(getQuoteById(quote?.id));
        }}
      />
    </div>
  );
};

export default AcceptQuoteLayout;
